import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { faLinkedin, faFacebook, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import logo from '../images/new_logo.svg';
import profile from '../images/new_logo.svg';
import algoliasearch from "algoliasearch";
import ShowResults from './ShowResults';
import { isNotEmpty, signupCall, loginCall } from "../util/user";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faFlagCheckered, faGift, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import logoSmall from '../images/new_logo.svg';
import { AuthContext } from "../util/context";
import renderIf from "render-if";
import VidBox from './VidBox'
import CustomPage from './listings/CustomPage'
import SearchCats from './SearchCats'
import Helmet from "react-helmet";

const GeneralBrowse = () => {
  let show;
  let communities = [
    {
      name: "Ancaster",
      slug: "Ancaster",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.shawnpalmer.ca%2Fimages%2Fcontent%2FAncaster-Ontario-street-view.jpg&f=1&nofb=1"
    },
    {
      name: "Brantford",
      slug: "Brantford",
      img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.narcity.com%2Fu%2F2018%2F04%2F18%2F25877367f1ed5beec4bafbbf2a2c5edf9474feb3.jpg_1200x630.jpg&f=1&nofb=1"
    },
    {
      name: "Burlington",
      slug: "Burlington",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.mcsrealestatewebsites.com%2FAssets%2FNeighbourhoods%2Fburlington-2.jpg&f=1&nofb=1"
    },
    {
      name: "Dundas",
      slug: "Dundas",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fimages.dailyhive.com%2F20170127065907%2FTravis-Singleton-%254020two19-Photography2.jpg&f=1&nofb=1"
    },
    {
      name: "Flamborough",
      slug: "Flamborough",
      img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.realtor.ca%2Flisting%2FTS636959526321700000%2Freb14%2Fhighres%2F6%2Fh4056186_2.jpg&f=1&nofb=1"
    },
    {
      name: "Grimsby",
      slug: "Grimsby",
      img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fpostmediatorontosun.files.wordpress.com%2F2018%2F02%2Fcover-image-main-street-and-ontario-street-cropped.jpg&f=1&nofb=1"
    },
    {
      name: "Hamilton",
      slug: "Hamilton",
      img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fcommons%2Fthumb%2F1%2F11%2FNorthEndHamilton.JPG%2F1200px-NorthEndHamilton.JPG&f=1&nofb=1"
    },
    {
      name: "Niagara",
      slug: "Niagara",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1"
    },
    {
      name: "Oakville",
      slug: "Oakville",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2Fplumber.ca%2Fwp-content%2Fuploads%2F2013%2F06%2Fo-OAKVILLE-ONTARIO-facebook.jpg&f=1&nofb=1"
    },
    {
      name: "Stoney Creek",
      slug: "Stoney Creek",
      img: "https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fvignette.wikia.nocookie.net%2Fprowrestling%2Fimages%2F7%2F79%2FStoney_Creek%252C_ON.jpg%2Frevision%2Flatest%3Fcb%3D20150104013334&f=1&nofb=1"
    },
    {
      name: "Waterdown",
      slug: "Waterdown",
      img: "https://proxy.duckduckgo.com/iu/?u=http%3A%2F%2F3.bp.blogspot.com%2F-b-2uzfhW2Fo%2FT5zRwgcckdI%2FAAAAAAAAJRo%2FG0p7LiZoGbk%2Fs1600%2FOntario_Canada_Niagara_Falls.jpg&f=1&nofb=1"
    }
  ]

  show = <SearchCats />

  return (
    <div className="ctn-jobs">
      <Helmet>
        <title>Hamilton Homes - Search for your properties</title>
        <meta name="description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
        <meta name="keywords" content="hamilton,homes,for,sale,search,condos,luxury,business"/>

        <meta property="og:url" content="https://besthamiltonhouses.com/general_browse"/>
        <meta property="og:title" content="Hamilton Homes - General Search"/>
        <meta property="og:description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
      </Helmet>

      <VidBox />

      <div className="bigger-zindex all-jobs">
        {show}
      </div>
    </div>
  );
};

export default withRouter(GeneralBrowse);
